/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_OBSERVACION_CASO (state, item) {
    state.observaciones_caso.unshift(item)
  },
  SET_OBSERVACION_CASO (state, observaciones_caso) {
    state.observaciones_caso = observaciones_caso
    state.meta.push(observaciones_caso.meta)
  },
  UPDATE_OBSERVACION_CASO (state, observacion_caso) {
    const productIndex = state.observaciones_caso.findIndex((p) => p.id === observacion_caso.id)
    Object.assign(state.observaciones_caso[productIndex], observacion_caso)
  },
  REMOVE_OBSERVACION_CASO (state, itemId) {
    const ItemIndex = state.observaciones_caso.findIndex((p) => p.id === itemId)
    state.observaciones_caso.splice(ItemIndex, 1)
  }
}
